export function calculateResidual(result) {
  if (!result?.meta?.zones) return;
  if (!result?.meta?.sampleMass) return;

  const zones = result.meta.zones;
  let relativeResidual = 1;
  const residual = {
    value: result.meta.sampleMass.value,
    units: result.meta.sampleMass.units,
  };
  for (let zone of zones) {
    if (residual.units !== zone.massLoss.units) {
      throw new Error('zone mass loss units different from sample mass units');
    }
    residual.value -= zone.massLoss.value;
    relativeResidual -= zone.relativeMassLoss;
  }
  zones.push({
    relativeMassLoss: relativeResidual,
    massLoss: residual,
    kind: 'Residual',
  });
}
